import ComingSoonPage from './ComingSoonPage';

export default ComingSoonPage;
